import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { NgIf, AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { Router } from '@angular/router';
import { RootState } from '@next/core-lib/app';
import { AuthorizationSelectors } from '@next/core-lib/authorization';
import { SummaryCardComponent } from '@next/core-lib/components';
import { TranslatePipe } from '@next/core-lib/i18n';
import { select, Store } from '@ngrx/store';
import { map, Observable, skipWhile, take } from 'rxjs';
import { TenantAwareTranslationService } from 'src/app/shared/services/tenant-aware-translation.service';

import { FinalSetupSettings } from '../../models/setting.model';
import * as settingActions from '../../store/actions/setting.actions';
import { getFinalSetupSettings } from '../../store/selectors/setting.selector';

@Component({
  selector: 'app-final-setup-setting',
  templateUrl: './final-setup-setting.component.html',
  styleUrls: ['./final-setup-setting.component.scss'],
  imports: [
    NgIf,
    SummaryCardComponent,
    MatSlideToggle,
    ReactiveFormsModule,
    FormsModule,
    MatFormField,
    MatInput,
    CdkTextareaAutosize,
    AsyncPipe,
    TranslatePipe,
  ],
})
export class FinalSetupSettingComponent {
  private readonly store = inject<Store<RootState>>(Store);
  private readonly router = inject(Router);
  private readonly tenantTranslation = inject(TenantAwareTranslationService);

  finalSetupSettingsCopy$: Observable<FinalSetupSettings>;

  // Tenant-aware translation labels
  representativeLabel = this.tenantTranslation.translate(
    'final-setup-setting.masterdata.representative-agrifirm',
  );
  memberLabel = this.tenantTranslation.translate('final-setup-setting.masterdata.agrifirm-member');

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {
    this.store
      .pipe(select(AuthorizationSelectors.hasAtLeastAdvisorRole), take(1))
      .subscribe((hasAtLeastAdvisorRole) => {
        if (hasAtLeastAdvisorRole) {
          this.finalSetupSettingsCopy$ = this.store.select(getFinalSetupSettings).pipe(
            skipWhile((finalSetupSettings) => !finalSetupSettings),
            map((finalSetupSettings) => ({
              ...finalSetupSettings,
              masterData: { ...finalSetupSettings.masterData },
            })),
          );
        } else {
          this.router.navigate(['/settings', 'barn']);
        }
      });
  }

  updateFinalSetupSettings(finalSetupSettings: FinalSetupSettings) {
    this.store.dispatch(
      settingActions.setFinalSetupSettings({ value: finalSetupSettings, save: true }),
    );

    this.store.dispatch(
      settingActions.upsertMasterDataRequest({ masterData: finalSetupSettings.masterData }),
    );
  }
}
